import { z } from 'zod';
import { isDateInFuture } from '@/shared/utils/dateUtils';

/**
 * Create validation schema for marking frames as ordered
 * @param requirePoNumber - Whether PO number is required
 */
export function createMarkAsOrderedSchema(requirePoNumber = false) {
  return z.object({
    frame_ids: z
      .array(z.string().uuid('Invalid frame ID'))
      .min(1, 'At least one frame must be selected'),

    po_number: requirePoNumber
      ? z
          .string()
          .min(1, 'PO number is required')
          .max(50, 'PO number must be 50 characters or less')
          .regex(
            /^[A-Za-z0-9-]+$/,
            'PO number can only contain letters, numbers, and dashes'
          )
      : z
          .string()
          .max(50, 'PO number must be 50 characters or less')
          .regex(
            /^[A-Za-z0-9-]*$/,
            'PO number can only contain letters, numbers, and dashes'
          )
          .optional()
          .transform((val) => val || ''),

    ordered_date: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format')
      .refine(
        (date) => !isDateInFuture(date),
        'Order date cannot be in the future'
      ),
  });
}

/**
 * Default validation schema (PO number required)
 * @deprecated Use createMarkAsOrderedSchema() instead
 */
export const markAsOrderedSchema = createMarkAsOrderedSchema(true);

export type MarkAsOrderedFormData = z.infer<typeof markAsOrderedSchema>;
